import { useQuery } from '@tanstack/react-query';

import { useProfile } from 'context/profile';
import { dischargeCalendarQueryKeys, indexDischargeCalendarWeek } from 'services/api/dischargeCalendar';
import {
  useDischargeCalendarFilters,
  useDischargeCalendarSearch,
  useWeekViewState,
} from 'stores/dischargeCalendarStore';

export default function useDischargeCalendarWeek() {
  const { profile } = useProfile();
  const filters = useDischargeCalendarFilters();
  const search = useDischargeCalendarSearch();
  const { startDate, endDate } = useWeekViewState();

  const queryParams = {
    startDate,
    endDate,
    filters,
    search,
  };

  return useQuery({
    queryKey: dischargeCalendarQueryKeys.week({
      clientId: profile.actingClientId,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      filters,
      search,
    }),
    queryFn: ({ signal }) => indexDischargeCalendarWeek(queryParams, signal),
    staleTime: 30000,
  });
}
